<template>
   <div class="sub-tree">
      <table-list
        class="sub-stock"
        :columns="columns"
        :data="tableList"
        :loading="loading"
        :showPage="false"
      >
      </table-list>
      <show-modal :subStockShowKey ="subStockShowKey" :stockFid="subStockFid" :showType="isShow" @refresh="getSubList(stockFid)"></show-modal>
      <lock-modal :subLockKey ="lockKey" :projectFid="projectFid" :stockFid="subStockFid" :lockType="lockType" @refresh="getSubList(stockFid)"></lock-modal>
      <batch-above-or-under-modal :isBatch="false" @refresh="getSubList(stockFid)" :subHandleUnderKey="handleUnderKey" :stockFidList = "stockFidList" :handleType="stockIsUnder"></batch-above-or-under-modal>
      <air-quality-report-modal :n="uploadKey" :moduleFid="subStockFid"></air-quality-report-modal>
      <IntellectDetail :n="intellectDetailKey" :projectFid="projectFid" :stockParentFid="stockParentFid" :stockFid="subStockFid" :stockNumber="stockNumber"></IntellectDetail>
      <set-labels :n="labelsN" :selection="selection" @refresh="getSubList(stockFid)"></set-labels>
      <edit-labels :n="editLabelsN" :stockFid="subStockFid"></edit-labels>
   </div>
</template>

<script type="text/ecmascript-6">
   import TableList from 'components/TableList/index';
   import ShowModal from './ShowModal';
   import BatchAboveOrUnderModal from './BatchAboveOrUnder';
   import LockModal from './LockModal';
   import { getSubList } from "api/house"
   import { formatMoney } from '@/utils/format'
   import AirQualityReportModal from './AirQualityReportModal';
   import IntellectDetail from './IntellectDetail';
   import SetLabels from './SetLabels'
   import EditLabels from './EditLabels'
   export default {
      props:{
         stockFid:{
            type:String,
            default:''
         },
      },
      created(){
         this.getSubList(this.stockFid)
      },
      components:{
         TableList,
         ShowModal,
         BatchAboveOrUnderModal,
         LockModal,
         AirQualityReportModal,
         IntellectDetail,
         SetLabels,
         EditLabels,
      },
      data () {
         return {
            selection:[],
            editLabelsN:0,
            labelsN:0,
            subStockShowKey:0,
            lockKey:0,
            lockType:0,
            handleUnderKey:0,
            uploadKey:0,
            subStockFid:'',
            stockParentFid:'',
            projectFid:'',
            stockNumber:'',
            intellectDetailKey:0,
            isShow:0, // 0为隐藏操作 1为显示操作
            stockIsUnder:0,
            stockFidList:'',
            loading :true,
            columns: [
               {
                  title: 'selection',
                  width: 60,
                  align: 'center'
               },
               {
                  title:'expend',
                  width: 50
               },
               {
                  title:' '
               },
               {
                  title: '房间号',
                  width:100,
                  key: 'stockNumber',
                  align: 'center',
                  render: (h,params)=>{
                     return h('a',{
                        on:{
                           click: () => {
                              // let projectId = params.row.projectId
                              const fid = params.row.fid
                              this.$router.push({ name: 'housedetail', params: {stockFid:fid }})
                           }
                        }
                     },params.row.stockNumber)

                  }
               },
               {
                  title:' '
               },
               {
                  title: '项目名称',
                  width:200,
                  key: 'projectName',
                  align: 'center'
               },
               {
                  title:' '
               },
               {
                  title: '房型名称',
                  width: 180,
                  key: 'houseTypeName',
                  align: 'center'
               },
               {
                  title:' '
               },
               {
                  title: '楼栋',
                  width: 100,
                  key: 'buildingName',
                  align: 'center'
               },
               {
                  title:' '
               },
               {
                  title: '楼层',
                  width: 60,
                  key: 'houseFloorNumber',
                  align: 'center'
               },
               {
                  title:' '
               },
               {
                  title: '出租类型',
                  width: 100,
                  key: 'stockRentTypeCn',
                  align: 'center'
               },
               {
                  title:' '
               },
               {
                  title: '风格',
                  width: 100,
                  key: 'stockDecorationstyleCn',
                  align: 'center'
               },
               {
                  title:' '
               },
               {
                  title: '房源状态',
                  width: 100,
                  key: 'stockStatusCn',
                  align: 'center'
               },
               {
                  title:' '
               },
               {
                  title: '面积',
                  width: 60,
                  key: 'stockArea',
                  align: 'center'
               },
               {
                  title:' '
               },
               {
                  title: '朝向',
                  key: 'stockDirectionCn',
                  width:100,
                  align: 'center'
               },
               {
                  title:' '
               },
               {
                  title: '出租价格',
                  width: 100,
                  key: 'stockRentPrice',
                  align: 'center',
                  render: (h,params) => {
                     return h('div',{
                        style:{
                           'text-align':'right'
                        }
                     },formatMoney(params.row.stockRentPrice))
                  }
               },
               {
                  title:' '
               },
               {
                  title: '优惠价',
                  width: 100,
                  key: 'discountPrice',
                  align: 'center',
                  render: (h,params) => {
                     return h('div',{
                        style:{
                           'text-align':'right'
                        }
                     },formatMoney(params.row.discountPrice))
                  }
               },
               {
                  title:' '
               },
               {
                  title: '优惠价有效期',
                  width: 100,
                  key: 'discountPriceTime',
                  align: 'center',
               },
               {
                  title:' '
               },
               {
                  title: '是否上架',
                  width: 100,
                  key: 'stockIsUnderCn',
                  align: 'center'
               },
               {
                  title:'状态',
                  width: 100,
                  key: 'stockIsShowCn',
                  align: 'center'
               },
               {
                  title: '空气检测报告',
                  width: 110,
                  key: 'airQualityReport',
                  align: 'center',
                  render:(h,params) => {
                     return h('a',{
                        on:{
                           click: () => {
                              this.subStockFid = params.row.fid
                              this.uploadKey++
                           }
                        }
                     },'配置')
                  }
               },
               {
                  title:' '
               },
               {
                  title: '房间标签',
                  width: 110,
                  align: 'center',
                  render:(h,params) => {
                  return h('a',[
                  //    h('a',{
                  //    style:{
                  //       marginRight: '5px',
                  //    },
                  //    directives: [
                  //       {
                  //       name: 'p',
                  //       value: {
                  //          api:'batchLabel/saveOrEdit'
                  //       }
                  //       }
                  //    ],
                  //    on:{
                  //       click: () => {
                  //          this.subStockFid = params.row.fid
                  //          this.selection = [{fid:this.subStockFid}]
                  //          this.labelsN++
                  //       }
                  //    }
                  // },'配置'),
                  h('a',{
                     directives: [
                        {
                        name: 'p',
                        value: {
                           api:'batchLabel/saveOrEdit'
                        }
                        }
                     ],
                     on:{
                        click: () => {
                           this.subStockFid = params.row.fid
                           this.editLabelsN++
                        }
                     }
                     },'配置')
                     ])
                  }
               },
               {
                  title:' '
               },
               {
                  title: '智能设备',
                  width: 110,
                  key: 'fid',
                  align: 'center',
                  render:(h,params) => {
                     return h('a',{
                        directives: [
                           {
                              name: 'p',
                              value: {
                                 api:'label/getConfigImg'
                              }
                           }
                        ],
                        on:{
                           click: () => {
                              this.subStockFid = params.row.fid
                              this.stockParentFid = params.row.stockParentFid
                              this.projectFid = params.row.projectFid
                              this.stockNumber = params.row.stockNumber
                              this.intellectDetailKey++
                           }
                        }
                     },'配置')
                  }
               },
               {
                  title:' '
               },
               {
                  title:'操作',
                  key:'action',
                  width:220,
                  //fixed: 'right',
                  align:'center',
                  render:(h,params) => {
                     return h('div',[h('a',{
                        directives:[
                           {
                              name:'p',
                              value:{
                                 api:'houseInfo/batchAboveOrUnder'
                              }
                           }
                        ],
                        style: {
                           marginRight: '5px',
                           display: params.row.stockStatus === 1 && params.row.stockIsUnder==0 ? 'none' : 'inline-block'
                        },
                        // props: {
                        // 	type:params.row.stockIsUnder==0 ? 'error' : 'success',
                        //   size:'small',
                        //   disabled:params.row.stockStatus === 1 && params.row.stockIsUnder==0
                        // },
                        on:{
                           click: () => {
                              // 0：已上架 1：已下架
                              if(params.row.stockIsUnder==0){
                                 // 下架操作
                                 this.stockIsUnder = 1
                              }else {
                                 // 上架操作
                                 this.stockIsUnder = 0
                              }
                              this.stockFidList = params.row.fid;
                              this.handleUnderKey++
                              //  this.lockStock(this.lockType,)
                           }
                        }
                     },params.row.stockIsUnder==0? '下架':'上架'),
                        h('a',{
                           // props: {
                           //   type:params.row.stockStatus==2 ?  'success' :'primary',
                           //   size:'small',
                           //    disabled:params.row.stockStatus === 1
                           // },
                           style: {
                              marginRight: '5px',
                              display: params.row.stockStatus === 1 ? 'none' : 'inline-block'
                           },
                           on:{
                              click: () => {
                                 // 0：待租中 1：已出租 2:锁定 3:配置中
                                 if(params.row.stockStatus==2){
                                    this.lockType = 0
                                    //解锁
                                 }else {
                                    this.lockType = 2
                                    // 锁定
                                 }
                                 this.projectFid = params.row.projectFid;
                                 this.subStockFid = params.row.fid
                                 this.lockKey++
                              }
                           }
                        },params.row.stockStatus==2? '解锁':'锁定'),
                        h('a',{
                           // props: {
                           //   type:params.row.stockIsShow==0 ?'success' : 'error',
                           // 	size:'small',
                           // },
                           style: {
                              marginRight: '5px'
                           },
                           on:{
                              click: () => {
                                 this.$emit('aaa')
                                 this.isShow = params.row.stockIsShow === 0 ? 1:0
                                 // console.log(params.row.stockIsShow,this.isShow)
                                 this.subStockFid = params.row.fid
                                 this.subStockShowKey++
                              }
                           }
                        },params.row.stockIsShow == 0? '显示':'隐藏')])
                  }
               }
            ],
            tableList:[]
         };
      },
      methods:{
         getSubList(stockFid){
            if(stockFid === '') return
            this.loading = true
            getSubList(stockFid).then(res => {
               this.tableList = res.data
               this.loading = false
            })
         }
      }
   }
</script>
